import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../core/api.service';
import { ToastService } from '../core/toast.service';

/** My Resumes — the service boxes (Civilian, Sports, Student, Test Drive, Federal). */
@Component({
  selector: 'app-my-resumes',
  template: `
  <div class="band big">Résumé Services <span class="now-open">NOW OPEN</span></div>
  <div class="service-grid">
    <a class="service-box" *ngFor="let s of services" [routerLink]="['/my-resumes', s.slug]">
      <div class="service-title">{{ s.title }}</div>
      <div class="service-art" [ngClass]="'art-' + (s.iconKey || 'briefcase')" [class.has-img]="!imgFailed[s.slug]">
        <img *ngIf="!imgFailed[s.slug]" [src]="'assets/services/' + s.slug + '.jpg'" [alt]="s.title" (error)="imgFailed[s.slug] = true">
        <span *ngIf="imgFailed[s.slug]">{{ icon(s.iconKey) }}</span>
      </div>
      <div class="service-tag">{{ s.tagline }}</div>
      <div class="service-count" *ngIf="s.myCount">{{ s.myCount }} saved</div>
    </a>
  </div>`
})
export class MyResumesComponent implements OnInit {
  services: any[] = [];
  /** Artwork lives in assets/services/<slug>.jpg — replace a file to change a picture; emoji shows if missing. */
  imgFailed: { [slug: string]: boolean } = {};
  constructor(private api: ApiService) {}
  ngOnInit() { this.api.get<any[]>('/resumes/services').subscribe(s => this.services = s); }
  icon(k: string) {
    return ({ briefcase: '💼', trophy: '🏆', graduation: '🎓', steering: '🚗', capitol: '🏛' } as any)[k] || '📄';
  }
}

/** One service page — description + the member's résumés of that type. */
@Component({
  selector: 'app-service-page',
  template: `
  <ng-container *ngIf="service">
    <div class="band big">
      {{ service.title }}
      <a class="back" routerLink="/my-resumes">‹ BACK</a>
    </div>
    <div class="card">
      <p class="lead">{{ service.tagline }}</p>
      <p class="muted">{{ service.description }}</p>
      <button class="btn primary" (click)="create()" [disabled]="atLimit()">+ Create New Résumé</button>
      <span class="muted small" *ngIf="atLimit()"> &nbsp;You have used your {{ service.maxResumesPerUser }} free résumé — open it below to keep editing.</span>
    </div>

    <div class="card">
      <div class="card-head">My {{ service.title }}</div>
      <div *ngIf="!resumes.length" class="empty">No résumés yet. Click <b>Create New Résumé</b> to start.</div>
      <table class="grid" *ngIf="resumes.length">
        <thead><tr><th>Title</th><th>Style</th><th>Status</th><th>Last saved</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let r of resumes">
            <td><a [routerLink]="['/my-resumes', service.slug, r.resumeId]"><b>{{ r.resumeTitle }}</b></a></td>
            <td class="cap">{{ r.templateStyle }}</td>
            <td><span class="chip" [class.ok]="r.status === 'FINAL'">{{ r.status }}</span></td>
            <td>{{ r.updatedAt | appDate:true }}</td>
            <td class="actions">
              <a class="btn sm" [routerLink]="['/my-resumes', service.slug, r.resumeId]">Edit</a>
              <button class="btn sm" *ngIf="!service.maxResumesPerUser" (click)="duplicate(r)">Copy</button>
              <button class="btn sm danger" (click)="remove(r)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>`
})
export class ServicePageComponent implements OnInit {
  service: any;
  resumes: any[] = [];
  constructor(private api: ApiService, private route: ActivatedRoute, private router: Router, private toast: ToastService) {}

  ngOnInit() { this.route.paramMap.subscribe(() => this.load()); }

  load() {
    const slug = this.route.snapshot.paramMap.get('slug');
    this.api.get('/resumes/services/' + slug).subscribe(
      r => { this.service = r.service; this.resumes = r.resumes; },
      e => { this.toast.err(ApiService.message(e)); this.router.navigate(['/my-resumes']); }
    );
  }

  atLimit() { return this.service.maxResumesPerUser && this.resumes.length >= this.service.maxResumesPerUser; }
  create() { this.router.navigate(['/my-resumes', this.service.slug, 'new']); }

  duplicate(r: any) {
    this.api.post('/resumes/' + r.resumeId + '/duplicate').subscribe(x => { this.toast.ok(x.message); this.load(); }, e => this.toast.err(ApiService.message(e)));
  }

  remove(r: any) {
    if (!confirm('Delete "' + r.resumeTitle + '"?')) { return; }
    this.api.delete('/resumes/' + r.resumeId).subscribe(x => { this.toast.ok(x.message); this.load(); }, e => this.toast.err(ApiService.message(e)));
  }
}
